import { render } from "./SectionOne.vue?vue&type=template&id=7b05f9d8&scoped=true&ts=true"
import script from "./SectionOne.vue?vue&type=script&lang=ts"
export * from "./SectionOne.vue?vue&type=script&lang=ts"

import "./SectionOne.vue?vue&type=style&index=0&id=7b05f9d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b05f9d8"]])

export default __exports__